export type { TooltipPlacement } from './Tooltip';
export { default } from './Tooltip';
